__turbopack_context__.v({
  "Label": "CommentsInputDesktop-module-scss-module__rFrxHG__Label",
  "actionable": "CommentsInputDesktop-module-scss-module__rFrxHG__actionable",
  "controls": "CommentsInputDesktop-module-scss-module__rFrxHG__controls",
  "inline": "CommentsInputDesktop-module-scss-module__rFrxHG__inline",
  "primary": "CommentsInputDesktop-module-scss-module__rFrxHG__primary",
  "primaryBtn": "CommentsInputDesktop-module-scss-module__rFrxHG__primaryBtn",
  "root": "CommentsInputDesktop-module-scss-module__rFrxHG__root",
  "secondaryBtn": "CommentsInputDesktop-module-scss-module__rFrxHG__secondaryBtn",
});
